 <template>
  <div>
    <base-progress
      type="default"
      :value="getProgress()"
      :label="$t('votedplayers')"
    ></base-progress>

    <div>
      <span v-if="nonVotedNames.length > 0"
        ><font-awesome-icon icon="clock" /> {{ nonVotedNames }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  computed: {
    numberOfNonVotedPlayers() {
      let count = 0;
      this.$store.getters.getPlayers.forEach((player) => {
        const votes = this.$store.getters.getActionPlanVotesByPlayer(player.id);
        if (votes.length < 3) {
          count++;
        }
      });

      return count;
    },
    nonVotedNames() {
      let count = 0;
      let string = "";
      this.$store.getters.getPlayers.forEach((player) => {
        const votes = this.$store.getters.getActionPlanVotesByPlayer(player.id);
        if (votes.length < 3) {
          if (count > 0) {
            // Add comma if more than one player
            string += ", ";
          }
          string += player.nick_name;
          count++;
        }
      });

      return string;
    },
  },
  methods: {
    getProgress() {
      if (this.nonVotedNames.length === 0) {
        return 100;
      } else {
        return (
          Math.round((1 -
            this.numberOfNonVotedPlayers /
              this.$store.getters.getNumberOfPlayers) *
          100)
        );
      }
    },
  },
};
</script>

<i18n>
  {
    "en": {
      "votedplayers":  "Voted players"
    },
    "fi": {
      "votedplayers":  "Äänestäneet pelaajat"
    },
    "sv": {
      "votedplayers": "Röstade spelare"
    },
    "de": {
      "votedplayers": "Gewählte Spieler"
    },
    "ko": {
      "votedplayers": "투표한 플레이어"
    }
  }
  </i18n>
